import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Icon } from "@iconify/react";
import { Col, Form } from "react-bootstrap";

const ClientFields = ({ field, index, id }) => {
  return field.type !== "contact" ? (
    <Col lg={index > 1 ? "12" : "6"}>
      <div className="fieldset mb-4">
        <Form.Group>
          <Form.Label>{field.title}</Form.Label>
          {(field.type === "text" ||
            field.type === "number" ||
            field.type === "email") && (
            <Form.Control
              type={field.type}
              required={field.required}
              pattern=".*\S+.*"
              title="White spaces are not allowed"
              disabled={field.disabled}
              value={field.value}
              onChange={(e) => field.onChange(e)}
              placeholder={field.title}
            />
          )}

          {field.type === "file" && (
            <div className="fileFull">
              <Form.Control
                id="fileUpdate"
                className="fileUpload"
                type={field.type}
                disabled={field.disabled}
                onChange={(e) => field.onChange(e)}
                placeholder={field.title}
              />
              <label htmlFor="fileUpdate" className="form-control">
                <span>
                  {field.value ? field.value.split("_")[1] : "No file chosen"}
                </span>
                <div className="btn btn-indigo">
                  Upload File{" "}
                  <small className="ms-2">
                    <Icon icon="uil:upload-alt" />
                  </small>
                </div>
              </label>
            </div>
          )}

          {field.type === "textarea" && (
            <textarea
              //  name=""
              placeholder={field.title}
              value={field.value ?? ""}
              required={field.required}
              onChange={(e) => field.onChange(e)}
              id={field.id}
              cols="30"
              rows="5"
              className="form-control"
            ></textarea>
          )}
        </Form.Group>
      </div>
    </Col>
  ) : (
    <Col lg={index > 1 ? "12" : "6"}>
      <div className="fieldset mb-4">
        <Form.Group className="contact-number">
          <Form.Label>{field.title}</Form.Label>
          <PhoneInput
            country={field.code}
            value={field.value}
            placeholder={field.title}
            inputProps={{ required: false }}
            inputClass="form-control"
            onChange={(phone) => field.onChange(phone)}
          />
        </Form.Group>
      </div>
    </Col>
  );
};

export default ClientFields;
